import { tabsKey } from '../Campaign/config';

const CampaignInfoModalCustomTabsConfig = [
    {
        tabKey: tabsKey.PromoDetails,
        buttonContent(handleClick, buttonName) {
            return <button onClick={handleClick(tabsKey.PromoDetails)}>{buttonName}</button>;
        },
        tabKeyForFilter: 'ApprovalRequest',
    },
    {
        tabKey: tabsKey.Campaign,
        buttonContent(handleClick, buttonName) {
            return <button onClick={handleClick(tabsKey.Campaign)}>{buttonName}</button>;
        },
        tabKeyForFilter: 'CampaignId',
    },
    {
        tabKey: tabsKey.Segment,
        buttonContent(handleClick, buttonName) {
            return <button onClick={handleClick(tabsKey.Segment)}>{buttonName}</button>;
        },
        tabKeyForFilter: 'SegmentId',
    },
    {
        tabKey: tabsKey.Template,
        buttonContent(handleClick, buttonName) {
            return <button onClick={handleClick(tabsKey.Template)}>{buttonName}</button>;
        },
        tabKeyForFilter: 'TemplateId',
    },
    {
        tabKey: tabsKey.Bonus,
        buttonContent(handleClick, buttonName) {
            return <button onClick={handleClick(tabsKey.Bonus)}>{buttonName}</button>;
        },
        tabKeyForFilter: 'BonusId',
    },
    {
        tabKey: tabsKey.ABTest,
        buttonContent(handleClick, buttonName) {
            return <button onClick={handleClick(tabsKey.ABTest)}>{buttonName}</button>;
        },
        tabKeyForFilter: 'ABTestId',
    },
];

export { CampaignInfoModalCustomTabsConfig };
